import React from "react";

import cx from "classnames";

import styles from "./MultiSelect.scss";

/**
 * A component to display when there are no suggestions to show
 */
export const MultiSelectSuggestionEmpty = ({
  emptySuggestionsComponent,
  listId,
  popperEnabled,
}: {
  /** Message to display when there are no suggestions */
  emptySuggestionsComponent: React.ReactNode;
  /** ID of the suggestions list */
  listId: string;
  popperEnabled: boolean;
}) => {
  return (
    <div
      className={cx(
        styles["suggestions-box"],
        styles["suggestions-box--with-items"],
        {
          [styles["suggestions-box--no-popper"]]: !popperEnabled,
        }
      )}
    >
      <ul
        className={styles["suggestions-list"]}
        data-testid="multiselect-suggestions-empty"
        role="listbox"
        id={listId}
      >
        <li className={styles["suggestion-row"]} role="option">
          {emptySuggestionsComponent}
        </li>
      </ul>
    </div>
  );
};
